import * as React from "react";
import moment from "moment";

import BasicTable from "../Table/BasicTable";
import { Field } from "../Table";
import { StatusLabel } from "../../Lists/Base/CompleteList/styles";

const DATE_FORMAT = "YYYY-MM-DD";

export default ({ invoices, handleRowClicked, selectedRow }) => {
  const data = React.useMemo(() => {
    let displayedInvoices = [];

    // map extra data
    displayedInvoices = invoices.map((i) => ({
      ...i,
      total: `${(i.InvoicedAmount.Value / 100)?.toLocaleString("sv")} ${
        i.InvoicedAmount.CurrencyCode
      }`,
      totalLeft: `${(i.CurrentAmount.Value / 100)?.toLocaleString("sv")} ${
        i.CurrentAmount.CurrencyCode
      }`,
    }));

    return displayedInvoices;
  }, [invoices]);

  const billectaStateMap = {
    None: "Okänd",
    Created: "Skapad",
    ReminderInvoiceSent: "Påminnelse",
    Manual: "Okänd",
    Completed: "Slutbetald",
    Cancelled: "Avbruten",
    InvoiceSent: "Skickad",
    Attested: "Attesterad",
    SentToDebtCollection: "Inkasso",
    SalesRequested: "SalesRequested",
    SaleRequestAccepted: "SaleRequestAccepted",
    SalesRequestedCancelled: "SalesRequestedCancelled",
    SalesRequestedDenied: "SalesRequestedDenied",
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Status",
        accessor: "Stage",
        Cell: (props) => {
          return (
            <StatusLabel state={billectaStateMap[props.value]}>
              {billectaStateMap[props.value]}
            </StatusLabel>
          );
        },
      },
      {
        Header: "Fakturanummer",
        accessor: "InvoiceNumber",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Kund",
        accessor: "DebtorName",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Belopp",
        accessor: "total",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Kvarvarande belopp",
        accessor: "totalLeft",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Attesterad",
        accessor: "AttestedDate",
        Cell: (props) => {
          return <Field>{props.value ? "Ja" : "Nej"}</Field>;
        },
      },
      {
        Header: "Fakturadatum",
        accessor: "InvoiceDate",
        Cell: (props) => {
          return <Field>{moment(props.value).format(DATE_FORMAT)}</Field>;
        },
      },
      {
        Header: "Förfallodatum",
        accessor: "DueDate",
        Cell: (props) => {
          return <Field>{moment(props.value).format(DATE_FORMAT)}</Field>;
        },
      },
      {
        Header: "Skapad",
        accessor: "Created",
        Cell: (props) => {
          return <Field>{moment(props.value).format(DATE_FORMAT)}</Field>;
        },
      },
    ],
    []
  );

  return (
    <>
      <BasicTable
        data={data}
        columns={columns}
        onRowClicked={handleRowClicked}
        selectedRow={selectedRow?.id}
        tableId="matchinvoicestable"
        withPersistantSortBy
        withPersistantGlobalFilter
      />
    </>
  );
};
